<style lang="less" scoped>
td {
  text-align: center;
  padding: 5px 5px;
  border: 2px solid #ebeef5;
}
table {
  margin-top: 10px;
  font-size: 14px;
  border-collapse: collapse;
  border: none;
}
.item-btn {
  height: 32px;
  margin: 4px 0px 0px 100px;
  line-height: 7px;
}
</style>
<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="tabClick">
        <el-tab-pane label="交流桩" name="acPile"></el-tab-pane>
        <el-tab-pane label="直流桩" name="dcPile"></el-tab-pane>
      </el-tabs>
      <div class="detail-content-body-div flex-1">
        <el-form
          :model="detailForm"
          :rules="pageConfig.formRules"
          ref="detailForm"
          label-width="120px"
          class="detail-form"
        >
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="资费（元/度）" prop="ttlVal">
                <el-input
                  style="width:320px;"
                  v-model="detailForm.ttlVal"
                  size="small"
                  @input="ttlValChange"
                ></el-input>
                <span style="margin-left:15px"
                  >更新人：{{ detailForm.lastModifiedByName }}</span
                >
                <span style="margin-left:15px"
                  >更新时间：{{ detailForm.lastModifiedWhen }}</span
                >
              </el-form-item>
              <div style="margin-bottom:16px;">
                <el-radio
                  v-model="detailForm.chargeType"
                  label="01"
                  @change="handleRadioChange('01')"
                  >固定费用</el-radio
                >
                <table style="width:60%;height:150px;">
                  <tr>
                    <td>时段</td>
                    <td>00时至次日00时</td>
                  </tr>
                  <tr>
                    <td>基本电费(元/kW.h)</td>
                    <td>
                      <el-input
                        v-model="items1.charingcost"
                        size="small"
                        :disabled="radioFlag1"
                        @input="handeleFeeChange1()"
                      ></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td>充电服务费(元/kW.h)</td>
                    <td>{{ items1.sercost }}</td>
                  </tr>
                </table>

                <div style="color: #ed3f14;font-size:12px;margin-top:10px;">
                  {{ tip1 }}
                </div>
              </div>
              <div>
                <el-radio
                  v-model="detailForm.chargeType"
                  label="02"
                  @change="handleRadioChange('02')"
                  >峰谷分时电费</el-radio
                >
                <table style="width:60%;height:150px;">
                  <tr>
                    <td>时段</td>
                    <td>
                      峰值&nbsp;<el-time-picker
                        style="width:300px"
                        size="small"
                        is-range
                        v-model="valleyTime"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="HH:mm"
                        format="HH:mm"
                        :disabled="radioFlag2"
                        @change="handleTimeChange"
                      ></el-time-picker>
                    </td>
                    <td>
                      谷值&nbsp;<el-time-picker
                        style="width:300px"
                        size="small"
                        is-range
                        v-model="peaksTime"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="HH:mm"
                        format="HH:mm"
                        disabled
                      ></el-time-picker>
                    </td>
                  </tr>
                  <tr>
                    <td>基本电费(元/kW.h)</td>
                    <td>
                      <el-input
                        v-model="items2[0].charingcost"
                        size="small"
                        :disabled="radioFlag2"
                        @input="handeleFeeChange21()"
                      ></el-input>
                    </td>
                    <td>
                      <el-input
                        v-model="items2[1].charingcost"
                        size="small"
                        :disabled="radioFlag2"
                        @input="handeleFeeChange22()"
                      ></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td>充电服务费(元/kW.h)</td>
                    <td>{{ items2[0].sercost }}</td>
                    <td>{{ items2[1].sercost }}</td>
                  </tr>
                </table>

                <div style="color: #ed3f14;font-size:12px;margin-top:10px;">
                  {{ tip2 }}
                </div>
                <div style="color: #ed3f14;font-size:12px;margin-top:10px;">
                  {{ tip3 }}
                </div>
              </div>
              <div class="flex" style="margin-top:16px;">
                <el-form-item label-width="0">
                  <el-radio
                    label="03"
                    v-model="detailForm.chargeType"
                    @change="handleRadioChange('03')"
                    >自定义分时电费</el-radio
                  >
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    size="small"
                    :disabled="radioFlag3"
                    @click="addTime"
                    style="margin-right:10px;"
                    >增加时间段</el-button
                  >
                  <span style="color:#F56C6C;">{{ zdytip }}</span>
                </el-form-item>
              </div>
              <div
                v-for="(item, index) in items"
                :key="index"
                track-by="$index"
                class="flex"
              >
                <el-form-item label-width="0">
                  <div class="flex" style="margin-top:5px;">
                    <Input
                      v-model="item.startTime"
                      style="width: 112px"
                      disabled
                    ></Input
                    >-
                    <TimePicker
                      :editable="false"
                      format="HH:mm"
                      v-model="item.endTime"
                      placeholder="Select time"
                      style="width: 112px"
                      :disabled="radioFlag3"
                      @on-change="chgStartTime(index)"
                    ></TimePicker>
                  </div>
                </el-form-item>
                <el-form-item label="基本电费（元/度）" label-width="150px">
                  <el-input
                    style="width:300px;"
                    v-model="item.charingcost"
                    size="small"
                    :disabled="radioFlag3"
                    @input="handeleFeeChange3"
                   
                  ></el-input>
                </el-form-item>
                <el-form-item label="充电服务费（元/度）" label-width="170px">
                  {{ item.sercost }}
                </el-form-item>
                <el-button
                  type="primary"
                  class="item-btn"
                  v-if="index != '0'"
                  @click="delTime(index)"
                  :disabled="radioFlag3"
                  >删除</el-button
                >
                <div
                  style="width:150px;color: #ed3f14;font-size:12px;margin:11px 0px 0px 10px;"
                >
                  {{ item.tip }}
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import config from "../../../config/config";
export default {
  data() {
    return {
      typeCode:'01',
        pileType:'',
      activeName: "acPile",
      pageConfig,
      editFlag: false,
      pageTitle: "资费新增",
      // 默认值设置
      detailForm: {},
      valleyTime: ["00:00", "23:59"],
      peaksTime: ["23:59", "00:00"],
      customTime: [],
      tip1: "",
      tip2: "",
      tip3: "",
      items1: {
        startTime: "00:00",
        endTime: "00:00",
        charingcost: "",
        sercost: "",
      },
      items2: [
        {
          startTime: "",
          endTime: "",
          charingcost: "",
          sercost: "",
        },
        {
          startTime: "",
          endTime: "",
          charingcost: "",
          sercost: "",
        },
      ],
      items: [
        {
          startTime: "00:00",
          endTime: "",
          charingcost: "",
          sercost: "",
          tip: "",
        },
      ],
      radioFlag1: false,
      radioFlag2: false,
      radioFlag3: false,
      flag1: false,
      flag21: false,
      flag22: false,
      flag3: false,
      zdytip: "",
      inputCheck: config.Reg.numberDecimal,
    };
  },
  methods: {
    tabClick(val) {
      console.log(val);
      if(val.name == 'acPile'){
        this.detailForm.typeCode = '01'
        this.typeCode = '01'
      }else if(val.name == 'dcPile'){
        this.detailForm.typeCode = '02'
        this.typeCode = '02'
      }else{
        this.typeCode = '01'
      
      }
        this.getdetailForm()
    },
    init() {
        
        console.log(this.detailForm.pileType);
      console.log(this.$store.state.stationObj.tId);
      if (this.$store.state.stationObj) {
        this.editFlag = true;
        this.pageTitle = "资费详情";
        // this.tabClick()
        this.typeCode = '01'
        // this.getFindChargePileTypeNo()
        this.getdetailForm();
        
      }
    },
    // 获取类型信息
    getFindChargePileTypeNo(){
        let _=this
        _.$H
        .post(_, _.$A.pilestation.findChargePileTypeNo, {
          stationNo: _.$store.state.stationObj.stationNo,
          pileType:this.pileType
        }).then(res=>{

        })
    },
    // 获取表单信息
    getdetailForm() {
      let _ = this;
      _.$H
        .post(_, _.$A.pilestation.findno, {
          chargeNo: _.$store.state.stationObj.chargeNo,
        stationNo: _.$store.state.stationObj.stationNo,
          typeCode:_.typeCode
        })
        .then((res) => {
            // if(res.data.data){
              
            // }
          _.detailForm = res.data.data || {};
          if (res.data.data) {
            if (res.data.data.chargeType == "01") {
              _.items1.charingcost = _.detailForm.fixedVal;
              if (_.detailForm.ttlVal - 0 == 0) {
                _.items1.sercost = 0;
              } else {
                _.items1.sercost = (
                  _.detailForm.ttlVal - _.items1.charingcost
                ).toFixed(2);
              }
              _.radioFlag1 = false;
              _.radioFlag2 = true;
              _.radioFlag3 = true;
              _.items =[
                  {
                    startTime: "00:00",
                    endTime: "",
                    charingcost: "",
                    sercost: "",
                    tip: "",
                  },
                ]
                _.items2=[
                  {
                    startTime: "",
                    endTime: "",
                    charingcost: "",
                    sercost: "",
                  },
                  {
                    startTime: "",
                    endTime: "",
                    charingcost: "",
                    sercost: "",
                  },
                ]
            } else if (res.data.data.chargeType == "02") {
              _.items2[1].charingcost = _.detailForm.baseVal;
              _.items2[0].charingcost = _.detailForm.highVal;
              _.valleyTime = [];
              _.peaksTime = [];
              _.valleyTime.push(_.detailForm.lowFrom);
              _.valleyTime.push(_.detailForm.lowTo);
              //峰值颠倒
              _.peaksTime.push(_.detailForm.lowTo);
              _.peaksTime.push(_.detailForm.lowFrom);
              if (_.detailForm.ttlVal - 0 == 0) {
                _.items2[0].sercost = 0;
                _.items2[1].sercost = 0;
              } else {
                _.items2[0].sercost = (
                  _.detailForm.ttlVal - _.items2[0].charingcost
                ).toFixed(2);
                _.items2[1].sercost = (
                  _.detailForm.ttlVal - _.items2[1].charingcost
                ).toFixed(2);
              }
              _.radioFlag1 = true;
              _.radioFlag2 = false;
              _.radioFlag3 = true;
              _.items1= {
                startTime: "00:00",
                endTime: "00:00",
                charingcost: "",
                sercost: "",
              }
              _.items =[
                  {
                    startTime: "00:00",
                    endTime: "",
                    charingcost: "",
                    sercost: "",
                    tip: "",
                  },
                ]
            } else if (res.data.data.chargeType == "03") {
              _.radioFlag1 = true;
              _.radioFlag2 = true;
              _.radioFlag3 = false;
              console.log(JSON.parse(res.data.data.userDefined));
              _.items = JSON.parse(res.data.data.userDefined);
              for (var i = 0; i < _.items.length; i++) {
                _.items[i].charingcost = _.items[i].chargeVal;
                if (_.detailForm.ttlVal - 0 == 0) {
                  _.items[i].sercost = 0;
                } else {
                 
                  _.items[i].sercost = (
                    _.items[i].totalVal - _.items[i].charingcost
                  ).toFixed(2);
                  // console.log(_.detailForm.ttlVal,_.items[i].sercost);
                }
              }
              _.items1= {
                startTime: "00:00",
                endTime: "00:00",
                charingcost: "",
                sercost: "",
              }
              _.items2=[
                  {
                    startTime: "",
                    endTime: "",
                    charingcost: "",
                    sercost: "",
                  },
                  {
                    startTime: "",
                    endTime: "",
                    charingcost: "",
                    sercost: "",
                  },
                ]
            }
          }
        });
    },
    handleRadioChange(radioVal) {
      let _ = this;
      if (radioVal == "01") {
        _.radioFlag1 = false;
        _.radioFlag2 = true;
        _.radioFlag3 = true;
      } else if (radioVal == "02") {
        _.radioFlag1 = true;
        _.radioFlag2 = false;
        _.radioFlag3 = true;
      } else {
        _.radioFlag1 = true;
        _.radioFlag2 = true;
        _.radioFlag3 = false;
      }
    },
    handleTimeChange(val) {
      if (val) {
        this.peaksTime = [];
        this.peaksTime[0] = val[1];
        this.peaksTime[1] = val[0];
        this.items2[0].startTime = val[0];
        this.items2[0].endTime = val[1];
        this.items2[1].startTime = val[1];
        this.items2[1].endTime = val[0];
      }
    },
    ttlValChange() {
      let _ = this;
      if (this.inputCheck.test(_.detailForm.ttlVal)) {
        if (_.detailForm.chargeType == "01") {
          _.handeleFeeChange1();
        } else if (_.detailForm.chargeType == "02") {
          _.handeleFeeChange21();
          _.handeleFeeChange22();
        } else if (_.detailForm.chargeType == "03") {
          _.handeleFeeChange3();
        }
      }
    },
    handeleFeeChange1() {
      this.tip1 = "";
      this.flag1 = false;

      if (this.$U.isEmpty(this.items1.charingcost)) {
        //这里只是条件判断
        this.items1.sercost = "";
        this.tip1 = "请输入基本电费";
      } else if (this.inputCheck.test(this.items1.charingcost)) {
        if (this.detailForm.ttlVal - 0 == 0) {
          this.items1.sercost = 0;
          this.tip1 = "";
          this.flag1 = true;
        } else {
          if (this.items1.charingcost - this.detailForm.ttlVal > 0) {
            this.tip1 = "基本电费需小于等于资费";
            this.items1.sercost = "";
            return false;
          } else if (this.inputCheck.test(this.detailForm.ttlVal)) {
            this.items1.sercost = (
              this.detailForm.ttlVal - this.items1.charingcost
            ).toFixed(3);
            this.tip1 = "";
            this.flag1 = true;
            return true;
          }
        }
      } else {
        this.tip1 = "请输入正确的数字(保留三位小数)";
      }
    },
    handeleFeeChange21() {
      this.tip2 = "";
      this.flag21 = false;
      if (this.$U.isEmpty(this.items2[0].charingcost)) {
        //这里只是条件判断
        this.items2[0].sercost = "";
        this.tip2 = "请输入谷值基本电费";
        return;
      } else if (this.inputCheck.test(this.items2[0].charingcost)) {
        if (this.detailForm.ttlVal - 0 == 0) {
          this.tip2 = "";
          this.items2[0].sercost = 0;
          this.flag21 = true;
        } else {
          if (this.items2[0].charingcost - this.detailForm.ttlVal > 0) {
            this.tip2 = "谷值基本电费需小于等于资费";
            this.items2[0].sercost = "";
          } else {
            if (this.inputCheck.test(this.detailForm.ttlVal)) {
              this.items2[0].sercost = (
                this.detailForm.ttlVal - this.items2[0].charingcost
              ).toFixed(3);
              this.tip2 = "";
              this.flag21 = true;
            }
          }
        }
      } else {
        this.tip2 = "请输入正确的数字(保留三位小数)";
      }
    },
    handeleFeeChange22() {
      this.tip3 = "";
      this.flag22 = false;
      if (this.$U.isEmpty(this.items2[1].charingcost)) {
        //这里只是条件判断
        this.items2[1].sercost = "";
        this.tip3 = "请输入峰值基本电费";
      } else if (this.inputCheck.test(this.items2[1].charingcost)) {
        if (this.detailForm.ttlVal - 0 == 0) {
          this.tip3 = "";
          this.items2[1].sercost = 0;
          this.flag22 = true;
        } else {
          if (this.items2[1].charingcost - this.detailForm.ttlVal > 0) {
            this.tip3 = "峰值基本电费需小于等于资费";
            this.items2[1].sercost = "";
          } else {
            if (this.inputCheck.test(this.detailForm.ttlVal)) {
              this.items2[1].sercost = (
                this.detailForm.ttlVal - this.items2[1].charingcost
              ).toFixed(3);
              this.tip3 = "";
              this.flag22 = true;
            }
          }
        }
      } else {
        this.tip3 = "请输入正确的数字(保留三位小数)";
      }
    },
    handeleFeeChange3(val) {
      console.log(val);
      this.flag3 = false;
      var mark = true;
      var len = this.items.length;
      for (var i = 0; i < len; i++) {
        this.items[i].tip = "";
        
        if (this.$U.isEmpty(this.items[i].charingcost)) {
          //这里只是条件判断
          this.items[i].sercost = "";
          this.items[i].tip = "需输入基本电费";
          mark = false;
        } else if (this.inputCheck.test(this.items[i].charingcost)) {
          // this.items[i].charingcost = val
          if (this.detailForm.ttlVal - 0 == 0) {
            this.items[i].tip = "";
            this.items[i].sercost = 0;
          } else {
            if (this.items[i].charingcost - this.detailForm.ttlVal > 0) {
              this.items[i].tip = "基本电费需小于等于资费";
              this.items[i].sercost = "";
              mark = false;
            } else {
              if (this.inputCheck.test(this.detailForm.ttlVal)) {
                this.items[i].sercost = (
                  this.detailForm.ttlVal - this.items[i].charingcost
                ).toFixed(3);
                this.items[i].tip = "";
              } else {
                mark = false;
              }
            }
          }
        } else {
          this.items[i].tip = "请输入正确的数字(保留三位小数)";
          mark = false;
        }
      }
      if (mark == true) {
        this.flag3 = true;
      }
      this.$forceUpdate();  //强制刷新
    },
    addTime() {
      var len = this.items.length;
      if (this.items[len - 1].endTime == "23:59") {
        this.zdytip = "已达最大值";
      } else if (this.items[len - 1].endTime == "") {
        this.zdytip = "请选择时间";
      } else if (this.items[len - 1].endTime <= this.items[len - 1].startTime) {
        this.zdytip = "时间选择错误";
      } else {
        this.newitems = {};
        var endTime = this.items[len - 1].endTime;
        this.newitems.startTime = endTime;
        this.items.push(this.newitems);
        this.zdytip = "";
      }
    },
    //第二个时间选择器的触发事件
    chgStartTime(index) {
      var len = this.items.length;
      if (index < len - 1) {
        //不是最后一个

        if (this.items[index].endTime <= this.items[index].startTime) {
          //当前的时间结束大于开始
          this.items[index].endTime = this.items[index + 1].startTime;
          this.zdytip = "时间选择错误";
        }
        if (
          this.items[index + 1].endTime != "" &&
          this.items[index + 1].endTime <= this.items[index].endTime
        ) {
          this.items[index].endTime = this.items[index + 1].startTime;
          this.zdytip = "时间选择错误";
        } else {
          this.zdytip = "";
          this.items[index + 1].startTime = this.items[index].endTime;
          this.items = Object.assign([], this.items);
        }
      } else if ((index = len - 1)) {
        if (this.items[index].endTime <= this.items[index].startTime) {
          this.items[index].endTime = "23:59";
        }
      }
    },
    //删除某个时间
    delTime(index) {
      this.chgEndTime(index);
      this.items.splice(index, 1);
    },
    chgEndTime(index) {
      var len = this.items.length;
      if (index > 0 && index != len - 1) {
        this.items[index + 1].startTime = this.items[index - 1].endTime;
        this.items = Object.assign([], this.items);
      }
    },
    // 表单提交
    submitForm(formName) {
      let _ = this;
      _.detailForm.corpNo = _.$store.state.corpNo;
      // _.detailForm.id = _.$store.state.stationObj.tId;
      _.detailForm.stationName = _.$store.state.stationObj.stationName;
      _.$refs[formName].validate((valid) => {
        if (valid) {
          if (_.detailForm.chargeType) {
            if (_.detailForm.chargeType == "01") {
              _.handeleFeeChange1();
              if (_.$U.isEmpty(_.items1.charingcost)) {
                _.$U.error("请输入基本电费");
                return;
              }
              if (_.items1.charingcost - _.detailForm.ttlVal > 0) {
                _.$U.error("基本电费需小于等于资费");
                return;
              }
              if (_.inputCheck.test(_.items1.charingcost)) {
                if (_.flag1) {
                  _.detailForm.fixedVal = _.items1.charingcost;
                }
              } else {
                _.$U.error("请输入正确的数字(保留三位小数)");
                return;
              }
            } else if (_.detailForm.chargeType == "02") {
              _.handeleFeeChange21();
              _.handeleFeeChange22();
              if (_.$U.isEmpty(_.items2[0].charingcost)) {
                _.$U.error("请输入谷值基本电费");
                return;
              }
              if (_.items2[0].charingcost - _.detailForm.ttlVal > 0) {
                _.$U.error("谷值基本电费需小于等于资费");
                return;
              }
              if (_.$U.isEmpty(_.items2[1].charingcost)) {
                _.$U.error("请输入峰值基本电费");
                return;
              }
              if (_.items2[1].charingcost - _.detailForm.ttlVal > 0) {
                _.$U.error("峰值基本电费需小于等于资费");
                return;
              }
              if (
                _.inputCheck.test(_.items2[0].charingcost) &&
                _.inputCheck.test(_.items2[1].charingcost)
              ) {
                if (_.flag21 && _.flag22) {
                  if (
                    _.items2[0].startTime == "" ||
                    _.items2[0].endTime == ""
                  ) {
                    _.detailForm.lowFrom = _.valleyTime[0];
                    _.detailForm.lowTo = _.valleyTime[1];
                  } else {
                    _.detailForm.lowFrom = _.items2[0].startTime;
                    _.detailForm.lowTo = _.items2[0].endTime;
                  }
                  _.detailForm.baseVal = _.items2[1].charingcost;
                  _.detailForm.highVal = _.items2[0].charingcost;
                }
              } else {
                _.$U.error("请输入正确的数字(保留三位小数)");
                return;
              }
            } else {
              _.handeleFeeChange3();
              for (var j = 0; j < _.items.length; j++) {
                if (_.$U.isEmpty(_.items[j].charingcost)) {
                  _.$U.error("请输入基本电费");
                  return;
                }
                if (_.items[j].charingcost - _.detailForm.ttlVal > 0) {
                  _.$U.error("基本电费需小于等于资费");
                  return;
                }
                if (_.inputCheck.test(_.items[j].charingcost)) {
                  if (_.flag3) {
                    let len = _.items.length;
                    let jsonArr = [];
                    for (var i = 0; i < len; i++) {
                      jsonArr[i] =
                        _.items[i].startTime +
                        ";" +
                        _.items[i].endTime +
                        ";" +
                        _.items[i].charingcost+";"+_.items[i].sercost;
                      // let obj = {
                      //   startTime:_.items[i].startTime,
                      //   endTime:_.items[i].endTime,
                      //   startTimeToEndTime:`${_.items[i].startTime}`+'-'+ `${_.items[i].endTime}`,
                      //   chargeVal:_.items[i].charingcost,
                      //   // totalVal:_.items[i].charingcost
                      // }
                      // debugger
                      // jsonArr.push(obj)
                    }
                    // console.log(jsonArr);
                    _.detailForm.customizeTimes = jsonArr;
                  }
                } else {
                  _.$U.error("请输入正确的数字(保留三位小数)");
                  return;
                }
              }
            }
            _.$U.showLoading(_);
            _.detailForm.stationNo = _.$store.state.stationObj.stationNo;
            
                _.detailForm.typeCode = _.typeCode
            
            // if(_.detailForm.id){
            //     _.$H.put(_,_.$A.pilestation.pilecharge,_.detailForm).then(res => {
            //         _.$U.success("保存成功")
            //         this.$router.push({
            //             name: pageConfig.listRouter
            //         });
            //     })
            // }else {
            _.$H
              .put(_, _.$A.pilestation.pilecharge, _.detailForm)
              .then((res) => {
                _.$U.success("保存成功");
                this.$router.push({
                  name: pageConfig.listRouter,
                });
                _.$U.hideLoading(_);
              });
            //}
          } else {
            _.$U.error("请选择电费类型");
          }
        }
      });
    },
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter,
      });
    },
  },
  mounted() {
   
    this.init();
  },
};
</script>
